export enum EAiActionStatus {
  Draft = 0,
  Published = 1
}
